import { render, staticRenderFns } from "./RefundPaymentModal.vue?vue&type=template&id=2bf2b040&scoped=true"
import script from "./RefundPaymentModal.vue?vue&type=script&lang=js"
export * from "./RefundPaymentModal.vue?vue&type=script&lang=js"
import style0 from "./RefundPaymentModal.vue?vue&type=style&index=0&id=2bf2b040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf2b040",
  null
  
)

export default component.exports